import { ReactNode } from 'react';
import styled from '@emotion/styled';

import { InViewSection } from '@shared/v2/components/InView';
import { SCREEN_SIZE } from '@shared/v2/constants';

import { STICKY_NAV_HEIGHT } from '@/v2/components/pages/PackageViewV2/constants';
import { PackagePageNavKey } from '../../types';

type SectionProps = {
  elementKey: PackagePageNavKey;
  children?: ReactNode;
};

const StyledSection = styled(InViewSection)`
  ${SCREEN_SIZE.LG} {
    scroll-margin-top: ${STICKY_NAV_HEIGHT}px;
  }
`;

const Section = (props: SectionProps) => <StyledSection {...props} />;

export default Section;
